import { useContext } from 'react';
import { HouseholdExpensesChartsDataContext } from '../contexts/HouseholdExpensesChartsDataContext';

export const useHouseholdExpensesChartsDataContext = () => {
    return useContext(HouseholdExpensesChartsDataContext);
};
